import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FormChoiceComponent } from './components/form-choice/form-choice.component';
import { FormPhotoComponent } from './components/form-photo/form-photo.component';
import { FormPressComponent } from './components/form-press/form-press.component';
import { FormComponent } from './components/form/form.component';
import { SuccessComponent } from './components/success/success.component';


const routes: Routes = [
  //{ path: '', component: FormComponent, pathMatch: 'full' },
  { path: '', component: FormComponent, pathMatch: 'full' }, //FormChoiceComponent
  { path: 'presse', component: FormPressComponent },
  { path: 'photographie', component: FormPhotoComponent },
  { path: 'video', component: FormComponent },
  { path: 'success', component: SuccessComponent },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
